module.exports = __webpack_public_path__ + "media/images/sp/stores/yokohama/yokohama_sns_05-509ef3ad4a7d2e1337f28581d33074e5.jpg";